export type Direction = 'in' | 'out' | 'full' | 'pinchZoomIn' | 'pinchZoomOut';

class UpdateZoom {
  direction: Direction;

  constructor(direction: Direction) {
    this.direction = direction;
  }
}

export default UpdateZoom;
